import { render, staticRenderFns } from "./fValue.vue?vue&type=template&id=b4359ce4&scoped=true"
import script from "./fValue.vue?vue&type=script&lang=js"
export * from "./fValue.vue?vue&type=script&lang=js"
import style0 from "./fValue.vue?vue&type=style&index=0&id=b4359ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4359ce4",
  null
  
)

export default component.exports